import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';

import { SharedComponentsCoreModule } from '@bp/shared/components/core';
import { SharedDirectivesModule } from '@bp/shared/directives';
import { SharedFeaturesSvgIconsModule } from '@bp/shared/features/svg-icons';
import { SharedFeaturesValidationModule } from '@bp/shared/features/validation';
import { SharedComponentsControlsModule } from '@bp/shared/components/controls';
import { SharedFeaturesSlidingStepRoutesModule } from '@bp/shared/features/sliding-step-routes';
import { SharedPipesModule } from '@bp/shared/pipes';
import { SharedFeaturesAnalyticsModule } from '@bp/shared/features/analytics';
import { SharedComponentsMetadataModule } from '@bp/shared/components/metadata';
import { SharedFeaturesOauthModule } from '@bp/shared/features/oauth';

import { AdminsSharedDomainsIdentityModule } from '@bp/admins-shared/domains/identity';

import { AdminsSharedPagesIntroRoutingModule } from './admins-shared-pages-intro-routing.module';
import {
	CreateAccountFormComponent, CreateAccountPageComponent, AcceptInvitePageComponent, IntroShellPageComponent,
	LoginFormComponent, LoginPageComponent, OtpVerificationFormComponent, RegisterAuthenticatorAppPageComponent, ResetPasswordFormComponent,
	ResetPasswordLinkSentPageComponent, ResetPasswordPageComponent, ResetPasswordVerificationPageComponent,
	SendResetPasswordLinkFormComponent, SendResetPasswordLinkPageComponent, SetSecurityQuestionsAnswersFormComponent,
	SetSecurityQuestionsAnswersPageComponent, OtpOnLoginFormComponent, OtpOnLoginPageComponent, SendResetAuthenticatorAppLinkPageComponent,
	ResetAuthenticatorAppLinkSentPageComponent, ResetAuthenticatorAppPageComponent, ResetAuthenticatorAppVerificationPageComponent,
	SessionExpiredPageComponent,
	IntroShellPageFooterComponent,
	EmailVerificationPageComponent,
	CreatePasswordPageComponent,
	CreatePasswordFormComponent
} from './pages';
import { ProvideSecurityQuestionAnswerFormComponent, RegisterAuthenticatorAppFormComponent } from './components';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatInputModule,
		MatFormFieldModule,
		MatButtonModule,
		MatCardModule,
		MatProgressBarModule,
		MatSelectModule,

		SharedComponentsCoreModule,
		SharedComponentsControlsModule,
		SharedComponentsMetadataModule,
		SharedDirectivesModule,
		SharedPipesModule,
		SharedFeaturesSvgIconsModule,
		SharedFeaturesValidationModule,
		SharedFeaturesSlidingStepRoutesModule,
		SharedFeaturesAnalyticsModule,
		SharedFeaturesOauthModule,

		AdminsSharedPagesIntroRoutingModule,
		AdminsSharedDomainsIdentityModule,
	],
	declarations: [
		IntroShellPageComponent,
		IntroShellPageFooterComponent,

		LoginPageComponent,
		LoginFormComponent,
		OtpOnLoginPageComponent,
		OtpOnLoginFormComponent,

		SessionExpiredPageComponent,
		RegisterAuthenticatorAppFormComponent,

		// signup-via-link
		AcceptInvitePageComponent,
		CreateAccountPageComponent,
		CreateAccountFormComponent,

		// #region deprecated, remove after accepting invite implementation by backend

		EmailVerificationPageComponent,
		CreatePasswordPageComponent,
		CreatePasswordFormComponent,

		// #endregion !deprecated

		// continue signup
		SetSecurityQuestionsAnswersPageComponent,
		SetSecurityQuestionsAnswersFormComponent,
		RegisterAuthenticatorAppPageComponent,

		// reset password
		SendResetPasswordLinkPageComponent,
		SendResetPasswordLinkFormComponent,
		ResetPasswordLinkSentPageComponent,
		ResetPasswordPageComponent,
		ResetPasswordFormComponent,
		ResetPasswordVerificationPageComponent,
		OtpVerificationFormComponent,

		// reset auth app
		SendResetAuthenticatorAppLinkPageComponent,
		ResetAuthenticatorAppLinkSentPageComponent,
		ResetAuthenticatorAppPageComponent,
		ResetAuthenticatorAppVerificationPageComponent,

		ProvideSecurityQuestionAnswerFormComponent,
	],

})
export class AdminsSharedPagesIntroModule { }
